<script>
  import { Map } from "mapbox-gl";
  import MapboxDraw from "@mapbox/mapbox-gl-draw";
  import { polygonToCells } from "h3-js";
  import { h3_MapBoxZoom_DrawnPolygon } from "../scripts/mapScripts/h3_MapBoxZoom";
  import { onMount, onDestroy } from "svelte";
  import "mapbox-gl/dist/mapbox-gl.css";
  import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";

  import Legend from "./Legend.svelte";
  import DropDown from "./DropDown.svelte";

  import LeftMenu from "./LeftMenu/LeftMenu.svelte";
  import BottomMenu from "./BottomMenu/BottomMenu.svelte";

  import * as turf from "@turf/turf";

  import {
    serverURL,
    radioCheck,
    drawingMode,
    districtAccess,
    districtFeatures,
  } from "./store";
  let Draw;
  let map;
  let mapContainer;
  let lng, lat, zoom;
  lng = 0;
  lat = 51.5;
  zoom = 7;

  onMount(() => {
    const initialState = { lng: lng, lat: lat, zoom: zoom };

    map = new Map({
      container: mapContainer,
      accessToken:
        "pk.eyJ1Ijoic3BhdGlhbGRlc2lnbmh1YiIsImEiOiJja216MGF5aDQwOTk1MnRwa3lzZWxzajVzIn0.xNma3vLd6Xad13rSCJXcFw",
      style: "mapbox://styles/spatialdesignhub/clwtf5q2a011801pc0l7723ms",
      center: [initialState.lng, initialState.lat],
      zoom: initialState.zoom,
      minZoom: 5,
      maxBounds: [
        [-15.0, 46.0], // Southwest coordinates (longitude, latitude)
        [6.0, 65.5], // Northeast coordinates (longitude, latitude)
      ],
      preserveDrawingBuffer: true,
    });

    map.on("style.load", () => {
      Draw = new MapboxDraw({
        displayControlsDefault: false,
        modes: {
          ...MapboxDraw.modes,
          simple_select: { ...MapboxDraw.modes.simple_select, dragMove() {} },
          direct_select: {
            ...MapboxDraw.modes.direct_select,
            dragFeature() {},
          },
        },
        controls: {
          polygon: true,
          trash: true,
        },
      });

      map.addControl(Draw);
      map.setPaintProperty("counties", "line-color", "transparent");

      document.getElementsByClassName("mapboxgl-ctrl-top-right")[0].style.top =
        "70px";

      if (window.location.hostname == "localhost") {
        $serverURL = "http://localhost:8080/";
      }
      // [
      //   ...document.getElementsByClassName("mapboxgl-ctrl-group mapboxgl-ctrl"),
      // ].forEach((d) => d.remove());
    });

    map.on("draw.create", updateH3FromDraw);
  });

  function updateH3FromDraw(e) {
    if ($drawingMode == true) {
      return;
    }

    const feature = e.features[0];
    console.log(feature)
    const geometry = feature.geometry.coordinates;

   let isWithin = false;

if ($districtAccess[0] !== "All") {
  const coords = geometry[0]; // outer ring of the polygon

  for (const coord of coords) {
    const pt = turf.point(coord);
    if (turf.booleanPointInPolygon(pt, $districtFeatures)) {
      isWithin = true;
      break;
    }
  }
}

    if (isWithin || $districtAccess == "All") {
      h3_MapBoxZoom_DrawnPolygon(map, feature, $radioCheck, $serverURL, Draw);
      
    } else {
      alert("Please draw in the district");
      Draw.deleteAll();
      return;
    }
  }
</script>

<LeftMenu {map} />
<BottomMenu {map} {Draw} />
<DropDown {map} {Draw} />

<Legend />

<div style="cursor:pointer" class="map-wrap">
  <div class="map" bind:this={mapContainer} />
</div>

<style>
  .map {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  * {
    overflow-y: hidden;
  }
</style>
